<template>
    <section class="character_upgrade">
        <div class="container-fluid">
            <div class="character_upgrade_main">
                <div class="left_menu_tab">
                    <div class="left_menu_tab_title">
                        <img src="../assets/images/character-upgrade-title.png" alt="">
                    </div>
                    <ul class="vertical dropdown menu" data-dropdown-menu style="max-width: 325px;">
                        <li>
                            <a href="#Item-1"><img src="../assets/images/icon-d1.png" alt=""><span>MY characterS</span></a>
                            <ul class="menu inner_drop">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame1.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/frame-lock.png" alt=""></a>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li class="comming_soon">
                            <a href="#Item-2"><img src="../assets/images/icon-d2.png" alt=""><span>SKINS upgrade <b>Coming Soon</b></span>
                            </a>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d3.png" alt=""><span>POWER upgrade</span></a>
                            <ul class="menu inner_drop power">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/power1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/power2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/power3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/power4.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/power5.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/power6.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d4.png" alt=""><span>Health upgrade</span></a>
                            <ul class="menu inner_drop health">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/health1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/health2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/health3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/health4.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/health5.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/health6.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d5.png" alt=""><span>Mobility upgrade</span></a>
                            <ul class="menu inner_drop mobility">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/mobility1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/mobility2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/mobility3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/mobility4.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/mobility5.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/mobility6.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d6.png" alt=""><span>Techniques upgrade</span></a>
                            <ul class="menu inner_drop technique">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/technique1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/technique2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/technique3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/technique4.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/technique5.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/technique6.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d7.png" alt=""><span>Range upgrade</span></a>
                            <ul class="menu inner_drop range">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/range1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/range2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/range3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/range4.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/range5.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/range6.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d8.png" alt=""><span>Speed upgrade</span></a>
                            <ul class="menu inner_drop speed">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/speed1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/speed2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/speed3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/speed4.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/speed5.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/speed6.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                        <li>
                            <a href="#Item-2"><img src="../assets/images/icon-d9.png" alt=""><span>MY LVL.UP CARD BUNDLE</span></a>
                            <ul class="menu inner_drop card_bundle">
                                <article class="row">
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/card-bundle1.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/card-bundle2.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                    <aside class="col-md-4">
                                        <a href="#"><img src="../assets/images/card-bundle3.png" alt=""></a>
                                        <div class="upgrade_button">
                                            <a href="#">
                                                <img src="../assets/images/upgrade_gray.png" alt="" class="gray">
                                                <img src="../assets/images/upgrade_orange.png" alt="" class="orange">
                                            </a>
                                        </div>
                                    </aside>
                                </article>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="character_img_up">
                    <img src="../assets/images/charecter-upgrade1.png" alt="">
                </div>
                <div class="purchase_ex">
                    <div class="purchase_head">
                        <a href="#"></a>
                    </div>
                    <div class='ui dropdown'>
                        <div class='text'><img src="../assets/images/purchase-exclusive.png" alt=""></div>
                        <div class='menu'>
                            <i class='dropdown icon'></i>
                            <div class='item'>
                                <article class="row">
                                    <aside class="col-md-4">
                                        <img src="../assets/images/drop1.png" alt="">
                                    </aside>
                                    <aside class="col-md-8">
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon1.png" alt="">
                                                <span>Lv P - 11</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon2.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon3.png" alt="">
                                                <span>Lv P - 05</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-button1.png" alt=""></a>
                                            </div>
                                        </div>
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon4.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon5.png" alt="">
                                                <span>Lv P - 04</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon6.png" alt="">
                                                <span>Lv P - 10</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-buy-button.png" alt=""></a>
                                            </div>
                                        </div>
                                    </aside>
                                </article>
                            </div>
                            <div class='item'>
                                <article class="row">
                                    <aside class="col-md-4">
                                        <img src="../assets/images/drop2.png" alt="">
                                    </aside>
                                    <aside class="col-md-8">
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon1.png" alt="">
                                                <span>Lv P - 11</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon2.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon3.png" alt="">
                                                <span>Lv P - 05</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-button1.png" alt=""></a>
                                            </div>
                                        </div>
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon4.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon5.png" alt="">
                                                <span>Lv P - 04</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon6.png" alt="">
                                                <span>Lv P - 10</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-buy-button.png" alt=""></a>
                                            </div>
                                        </div>
                                    </aside>
                                </article>
                            </div>
                            <div class='item'>
                                <article class="row">
                                    <aside class="col-md-4">
                                        <img src="../assets/images/drop3.png" alt="">
                                    </aside>
                                    <aside class="col-md-8">
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon1.png" alt="">
                                                <span>Lv P - 11</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon2.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon3.png" alt="">
                                                <span>Lv P - 05</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-button1.png" alt=""></a>
                                            </div>
                                        </div>
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon4.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon5.png" alt="">
                                                <span>Lv P - 04</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon6.png" alt="">
                                                <span>Lv P - 10</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-buy-button.png" alt=""></a>
                                            </div>
                                        </div>
                                    </aside>
                                </article>
                            </div>
                            <div class='item'>
                                <article class="row">
                                    <aside class="col-md-4">
                                        <img src="../assets/images/drop4.png" alt="">
                                    </aside>
                                    <aside class="col-md-8">
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon1.png" alt="">
                                                <span>Lv P - 11</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon2.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon3.png" alt="">
                                                <span>Lv P - 05</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-button1.png" alt=""></a>
                                            </div>
                                        </div>
                                        <div class="drop_left">
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon4.png" alt="">
                                                <span>Lv P - 08</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon5.png" alt="">
                                                <span>Lv P - 04</span>
                                            </div>
                                            <div class="drop_left_inner">
                                                <img src="../assets/images/drop-icon6.png" alt="">
                                                <span>Lv P - 10</span>
                                            </div>
                                            <div class="drop_button">
                                                <a href="#"><img src="../assets/images/drop-buy-button.png" alt=""></a>
                                            </div>
                                        </div>
                                    </aside>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="power_upgrade">
                <article class="row">
                    <aside class="col-md-6">
                        <div class="power_upgrade_inner">
                            <h4>POWER upgrade</h4>
                            <div class="power_upgrade_range">
                                <ul>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <span>06</span>
                            </div>
                        </div>
                        <div class="power_upgrade_inner">
                            <h4>Health upgrade</h4>
                            <div class="power_upgrade_range">
                                <ul>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <span>07</span>
                            </div>
                        </div>
                        <div class="power_upgrade_inner">
                            <h4>Mobility upgrade</h4>
                            <div class="power_upgrade_range">
                                <ul>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <span>05</span>
                            </div>
                        </div>
                    </aside>
                    <aside class="col-md-6">
                        <div class="power_upgrade_inner">
                            <h4>Techniques upgrade</h4>
                            <div class="power_upgrade_range">
                                <ul>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <span>05</span>
                            </div>
                        </div>
                        <div class="power_upgrade_inner">
                            <h4>Range upgrade</h4>
                            <div class="power_upgrade_range">
                                <ul>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <span>06</span>
                            </div>
                        </div>
                        <div class="power_upgrade_inner">
                            <h4>Speed upgrade</h4>
                            <div class="power_upgrade_range">
                                <ul>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li class="active"></li>
                                    <li></li>
                                </ul>
                                <span>09</span>
                            </div>
                        </div>
                    </aside>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "CharactersUpgrade"
}
</script>

<style scoped>
/*@import "../assets/css/dropdown.css";*/
/*@import "//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css";*/
/*@import "//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css";*/
/*@import "https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.7.3/tiny-slider.css";*/
/*@import "https://oss.maxcdn.com/semantic-ui/2.1.8/semantic.min.css";*/
</style>
